export default "__VITE_ASSET__4b6da43e__"